// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.other.zIndex.dialogModal - 1, // Below modals but above content
    overflow: 'hidden',
    backgroundColor: theme.colors.gray2[6],
    borderTopLeftRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    borderTopRightRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
  },

  content: {
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '17px 16px',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  title: {
    color: theme.white,
    fontSize: 16,
    fontWeight: 900,
    lineHeight: '24px',
  },

  expandButton: {
    backgroundColor: theme.colors.gray2[5],
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 1000,
    width: 40,
    height: 40,
    padding: 0,
    minWidth: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover': {
      backgroundColor: theme.colors.gray2[4],
    },
  },

  subtitle: {
    display: 'flex',
    gap: theme.other.spacing._12,
    alignItems: 'center',
    marginTop: theme.other.spacing._12,
  },

  notification: {
    display: 'flex',
    gap: theme.other.spacing._4,
    alignItems: 'center',
  },

  notificationText: {
    color: theme.colors.gray2[3],
    fontSize: 12,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },

  pip: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.colors.red[2],
    flexShrink: 0,
  },
}));

export default useStyles;
